<template>
  <div>
    <div class="box-save-minus">
<!--      <div class="typeface-size" :style="{ fontSize: fontSize + 'px' }">-->
<!--        第 {{ TextareaNum }} 题 (文章题)-->
<!--      </div>-->
      <div class="font-size-save-minus">
        <el-button size="small" @click="increaseFontSize">+</el-button>
        <span>{{ text }}</span>
        <el-button size="small" @click="decreaseFontSize">-</el-button>
      </div>
    </div>
    <!-- <div class="name">第 {{ TextareaNum }} 题 (主观题)</div> -->
<!--    <div class="name" :style="{ fontSize: fontSize + 'px' }">{{ TextareaContent }}:</div>-->
    <div class="name" :style="{ fontSize: fontSize + 'px' }" v-html="TextareaContent"></div>
    <div class="answer">
      <el-upload
        ref="upload"
        class="upload-demo"
        drag
        :action="uploadImgUrl"
        :show-file-list="true"
        :multiple="false"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload"
        :on-preview="handlePreview"
        :on-remove="removeFile"
        :headers="headers"
        :file-list="fileList"
        :limit="1">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传doc/docx文件</div>
      </el-upload>
    </div>
  </div>
</template>
<script>
import request from "@/request";
import Base64 from "base-64";

export default {
  props: {
    fontSize: {
      type: Number,
      require: true,
      default: 16,
    },
    TextareaNum: {
      type: Number,
      require: true,
      default: 0,
    },
    TextareaContent: {
      type: String,
      require: true,
    },
    dataId: {
      type: String | Number,
      require: true,
    },
    currentAnswer: {
      type: String,
    },
  },
  data() {
    return {
      answer: null,
      text: "字号",
      // fontSize: 16, // 初始字体大小
      uploadImgUrl: request.uploadFile, // 上传的图片服务器地址
      headers: {
        Authorization: this.$cookies.get(this.$commons.User.Authentication),
      },
      fileType: ["doc", "docx"],
      uploadFileType: ["doc", "docx"],
      fileList:[]
    };
  },
  watch: {

  },
  computed: {
    radioLabelStyle() {
      return {fontSize: this.fontSize + "px"};
    },
  },
  created() {
    if (this.currentAnswer) {
      // 处理URL中的查询参数和哈希
      const cleanUrl = this.currentAnswer.split('?')[0].split('#')[0];

      // 分割路径并获取最后一部分
      const parts = cleanUrl.split('/');
      const filenameWithExt = parts[parts.length - 1];
      this.fileList=[{
        name: filenameWithExt,
        url: this.currentAnswer,
      }]
    }
  },
  methods: {
    onSubmit() {
      return {No: this.TextareaNum, answer: this.answer, dataId: this.dataId};
    },
    utf8ToBase64(str) {
      return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
          return String.fromCharCode(parseInt(p1, 16));
        })
      );
    },
    handlePreview(file){
      console.log('preview', file);

      if (file.response) {
        console.log('preview-url', file.response.data.url);
        const url = file.response.data.url
        let iframeSrc = 'http://sjzhrgroup.com:8012/onlinePreview?url=' +this.utf8ToBase64(url)  + '&watermarkTxt=' + encodeURIComponent('考试')
        window.open(iframeSrc);
      } else if (file.url) {
        const url = this.utf8ToBase64(file.url);
        // const url = this.utf8ToBase64('https://www.sjzhrgroup.com/statics/2023/03/03/学位证_20230303160051A160.docx');
        console.log('123',url);
        let iframeSrc = 'http://sjzhrgroup.com:8012/onlinePreview?url=' +url  + '&watermarkTxt=' + encodeURIComponent('考试')

        // window.open(file.url);
        window.open(iframeSrc);
      }

    },
    removeFile(file, fileList){
      this.$refs.upload.clearFiles();
      this.$emit("remove",{No: this.TextareaNum, dataId: this.dataId})
    },
    // 上传前loading加载
    handleBeforeUpload(file) {
      console.log('handleBeforeUpload',file.type);
      const isJPG = file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || file.type === "application/msword";
      if (!isJPG) {
        this.$message.error("上传文件只能是 doc/docx 格式!");
        return false;
      }
      const isLt = file.size / 1024 / 1024 < 50;
      if (!isLt) {
        this.$modal.msgError(`上传文件大小不能超过 50MB!`);
        return false;
      }

      this.$modal.loading("正在上传，请稍候...");
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      let _this = this;
      _this.$forceUpdate();
      this.handler(file.response.data.url)
      _this.$modal.closeLoading();
    },
    handler(e) {
      this.$emit("change", {No: this.TextareaNum, answer: e, dataId: this.dataId});
    },
    increaseFontSize() {
      if (this.fontSize == 28) {
        this.$message({
          message: "已达到最大值",
          type: "warning",
        });
      } else {
        this.fontSize += 2;
      }
    },
    decreaseFontSize() {
      if (this.fontSize == 10) {
        this.$message({
          message: "已达到最小值",
          type: "warning",
        });
      } else {
        this.fontSize -= 2;
      }
    },
  },
};
</script>
<style scoped>
.answer {
  width: 100%;
}

.el-textarea >>> .el-textarea__inner {
  width: 100%;
  border: 2px solid rgb(64, 112, 179);
  padding: 26px 30px;
  resize: vertical;
  /* font-size: 24px; */
  font-size: inherit;
}

.name {
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 30px;
}

.box-save-minus {
  height: 50px;
}

.typeface-size {
  float: left;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
}

.font-size-save-minus {
  font-family: 思源黑体;
  float: right;
}


</style>




// WEBPACK FOOTER //
// src/components/topicArticle.vue